import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Footer from 'components/ui/Footer';

const NotFound = () => {
  return (
    <div className="min-h-screen gradient-background-main">
      <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="w-24 h-24 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="AlertTriangle" size={48} color="white" />
          </div>
          <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-text-primary mb-4">Page Not Found</h2>
          <p className="text-text-secondary mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/landing-page"
            className="btn-primary w-full py-3 text-center inline-block"
          >
            Go to Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="w-full py-3 px-6 border-2 border-primary text-primary rounded-lg font-semibold hover:bg-primary hover:text-white transition-all duration-250"
          >
            Go Back
          </button>
        </div>
      </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default NotFound;